import { Link } from 'react-router-dom';
import { seiyuuList } from '@/mocks/seiyuu';

const featured = seiyuuList.slice(0, 4);

export default function SeiyuuSection() {
  return (
    <section className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-18">
      <div className="flex items-end justify-between gap-4 mb-8">
        <div>
          <span className="inline-flex items-center gap-1.5 text-xs font-medium uppercase tracking-wider text-accent-700">
            <i className="ri-mic-2-line" />
            配音演员
          </span>
          <h2 className="mt-1 font-heading text-2xl md:text-3xl font-bold text-foreground-950">声优表精选</h2>
        </div>
        <Link to="/seiyuu" className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-700 hover:text-primary-600 whitespace-nowrap">
          完整声优表
          <i className="ri-arrow-right-line" />
        </Link>
      </div>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {featured.map((sv) => (
          <Link
            key={sv.id}
            to="/seiyuu"
            className="group flex gap-4 rounded-xl border border-background-200/70 bg-background-100 p-4 transition-colors hover:border-primary-300 hover:bg-background-50"
          >
            <img
              src={sv.image}
              alt={`声优 ${sv.name}`}
              className="h-16 w-16 shrink-0 rounded-full object-cover ring-2 ring-accent-200 group-hover:ring-accent-400 transition"
              loading="lazy"
            />
            <div className="min-w-0">
              <h3 className="truncate font-medium text-sm text-foreground-950">{sv.name}</h3>
              <p className="mt-0.5 flex items-center gap-1 text-xs text-foreground-500">
                <i className={`${sv.gender === '女' ? 'ri-women-line' : 'ri-men-line'} text-accent-600`} />
                {sv.gender} · {sv.debut} 出道
              </p>
              <p className="mt-1.5 line-clamp-2 text-xs leading-5 text-foreground-600">
                {sv.representative.map((r) => r.role).slice(0, 2).join(' / ')}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}